import React from 'react';
import { DialogTitle, DialogContent, Typography } from '@mui/material';
import { SimpleModal } from 'components/Modal';
import { StyledButton } from 'components/Buttons/DefaultButton/DefaultButton.styles';
import { ModalButtonContainer } from '../FeedbackPage.styles';

interface PositiveSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  hygienistFirstName: string;
}

const PositiveSuccessModal: React.FC<PositiveSuccessModalProps> = ({
  isOpen,
  onClose,
  hygienistFirstName,
}) => {
  return (
    <SimpleModal isOpen={isOpen} onClose={onClose}>
      <DialogTitle sx={{ textAlign: 'center' }}>Thank You!</DialogTitle>
      <DialogContent>
        <Typography align="left" gutterBottom>
          Great! They are now one of your {localStorage.getItem('userCountry') === 'US' ? 'Favorites' : 'Favourites'} and will have exclusive first access to your future job postings.
          <br /><br />
          <b>A friendly reminder:</b> Standard placement fees apply to future shifts booked with {hygienistFirstName} - whether arranged on the app or through direct contact.
        </Typography>
      </DialogContent>
      <ModalButtonContainer>
        <StyledButton
          variant="contained"
          onClick={onClose}
        >
          OK
        </StyledButton>
      </ModalButtonContainer>
    </SimpleModal>
  );
};

export default PositiveSuccessModal;
